export default __webpack_public_path__ + "static/media/unChecked.7bb173a1.svg";